module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"cancel":"Abbrechen","signingIn":"Anmeldung erfolgt…"},"en":{"cancel":"Cancel","signingIn":"Signing in…"}}')
  delete Component.options._Ctor
}
